import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const serviceDrawOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "服务类目名称",
            prop: "superiorName",
            type: 'select',
            span: 13,
            search: true,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "服务项目名称",
            prop: "name",
            type: 'input',
            span: 13,
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
        },
        {
            label: "服务抽成规则",
            prop: "formCount",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "工程师",
        //     prop: "name",
        //     type: 'select',
        //     formsolt:true,
        //     hide:true,
        // },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};